<template>
  <div class="notice-board">
    <img src="../assets/svg/maintenance.svg" />
    <h1>Sistema em manutenção</h1>
    <p>Estamos em manutenção. Por favor, volte mais tarde.</p>
    <button class="action" @click="reload">
      <img alt="Recarregar página" src="../assets/svg/reload.svg">
    </button>
  </div>
</template>
<script>
import { ConfigService } from "../services";
export default {
  name: "Maintenance",

  async beforeCreate() {
    // Verifica se o site ainda está em manutenção
    await ConfigService.getStatusSystem();
    // Atualiza o status de acordo com a resposta da API
    const inMaintenance = localStorage.getItem("maintenance");
    if (!inMaintenance) await this.$router.push("/");
  },

  methods: {
    reload() {
      history.go(0);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/css/variables.scss";

.notice-board {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2em;
  background-color: $branco-neutro;
  border-radius: 10px;

  > img {
    width: 6em;
    margin: 2em 0;
  }

  h1 {
    text-align: center;
    color: $azul-principal;
  }

  p {
    text-align: center;
  }

  .action img {
    margin: auto;
  }
}
</style>
